import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useAppSelector } from '../../app/hooks'

const useZoneAdverts = () => {
  const history = useHistory()
  const location = useLocation()

  const [disabledZoneId, setDisabledZoneId] = useState<string | null>(null)

  // =======================
  // 📦 Selectors
  // =======================
  const {
    data: detectedZonesData,
    loading: detectedZonesLoading,
    error: detectedZonesError,
    userCoords,
  } = useAppSelector((state) => state.detectedZones)

  // =======================
  // 🛠️ Handlers
  // =======================
  const handleGoToZoneIntro = async (zoneId: string) => {
    if (!zoneId) return
    history.push({
      pathname: `/intro/${zoneId}`,
      search: location.search, // preserves ?lat=...&lng=...
    })
  }

  const handleShowDisabledOverlay = (zoneId: string) => {
    setDisabledZoneId(zoneId)
    setTimeout(() => setDisabledZoneId(null), 1000)
  }

  return {
    data: detectedZonesData,
    loading: detectedZonesLoading,
    error: detectedZonesError,
    disabledZoneId,
    handlers: {
      handleGoToZoneIntro,
      handleShowDisabledOverlay,
    },
  }
}

export default useZoneAdverts
